import { fromJS } from 'immutable';
const action = name => `/test/${name}`;

//get user activitiy
export const GET_USER_ACTIVITY = action('GET_USER_ACTIVITY');
export const GET_USER_ACTIVITY_SUCCESS = action('GET_USER_ACTIVITY_SUCCESS');
export const ERROR_GET_USER_ACTIVITY = action('ERROR_GET_USER_ACTIVITY');

export const getUserActivity = data => ({ type: GET_USER_ACTIVITY, data });
export const getUserActivitySuccess = data => ({ type: GET_USER_ACTIVITY_SUCCESS, data });
export const errorGetUserActivity = data => ({ type: ERROR_GET_USER_ACTIVITY, data });

//upade click value
export const UPD_USER_CLICK = action('UPD_USER_CLICK');
export const ERROR_UPD_USER_CLICK = action('ERROR_UPD_USER_CLICK');

export const updUserClick = data => ({ type: UPD_USER_CLICK, data });
export const errorupdUserClick = data => ({ type: ERROR_UPD_USER_CLICK, data });

//update View value
export const UPD_USER_VIEW = action('UPD_USER_VIEW');
export const ERROR_UPD_USER_VIEW = action('ERROR_UPD_USER_VIEW');

export const updUserView = data => ({ type: UPD_USER_VIEW, data });
export const errorupdUserView = data => ({ type: ERROR_UPD_USER_VIEW, data });

const initialState = fromJS({

});

const activity = (state = initialState, action) => {
  switch (action.type) {

    //update View value
    case ERROR_UPD_USER_VIEW:
      return state = action.data;

    //upade click value
    case ERROR_UPD_USER_CLICK:
      return state = action.data;

    //get user activitiy
    case GET_USER_ACTIVITY_SUCCESS:
      return state.set('activity', action.data);
    case ERROR_GET_USER_ACTIVITY:
      return state = action.data;


    default:
      return state;
  }
};
export default activity;


// WEBPACK FOOTER //
// ./src/ducks/activity.js